import React, { useState } from "react";
import { connect } from "react-redux";
import { uploadLicense } from "./licenseService";
import { useHistory } from "react-router-dom";
import { Server } from "lucide-react";

function LicenseUploadSection({ licenseKey }) {

    const [newLicenseKey, setNewLicenseKey] = useState('');
    const [editMode, setEditMode] = useState(false);
    const history = useHistory();

    const onSubmitClick = () => {
        if (editMode) {
            return uploadLicense(newLicenseKey).then(() => history.push('/'));
        }
        setEditMode(true);
    }

    const getMaskedKey = (key) => {
        if (!key) return '';
        if (key.length <= 30) return key;
        const first15 = key.substring(0, 15);
        const last15 = key.substring(key.length - 15);
        const asterisks = '*'.repeat(key.length - 30);
        return `${first15}${asterisks}${last15}`;
    };

    return (
        <div className="oct_license-key-section-v2">
            <label>
                <Server className="oct_icon" />
                License Key
            </label>
            <div className="oct_key-input-row">
                <textarea
                    className='oct_key-textarea'
                    rows={3}
                    readOnly={!editMode}
                    value={editMode ? newLicenseKey : getMaskedKey(licenseKey)}
                    onChange={(event) => setNewLicenseKey(event.target.value)}
                />
                <button
                    className="oct_settings-btn-v2 oct_license-submit-btn-v2"
                    onClick={onSubmitClick}
                >
                    {editMode ? 'Submit' : 'Change'}
                </button>
            </div>
        </div>
    )

}

function mapStateToProps(state) {
    const license = state.licensePage.license || {}
    return {
        licenseKey: license.licenseKey || ''
    }
}

export default connect(mapStateToProps)(LicenseUploadSection);